import React, { Component, PropTypes as pt } from 'react';
import _ from 'underscore';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/lib/fa/';


function getFirstNavItem (p) {
    // return _.findWhere(p, {sortOrder: 1});
    return _.find(p, function (el, key) {
        return typeof el === 'object' && el.sortOrder === 1;
    })
}


class Navigation extends Component {
    constructor (props) {
        super(props);

        this.state = {
            // active: getFirstNavItem(props.preference)
            mobileOpen: false
        };

        this.getNavItems = this.getNavItems.bind(this);
        this.handleNav = this.handleNav.bind(this);
        this.toggleMobileView = this.toggleMobileView.bind(this);
    }

    shouldComponentUpdate (nextProps, nextState) {
        return (
            this.state !== nextState ||
            this.props.nav !== nextProps.nav
        );
    }

    // @XXX: Hoist up above this component?
    getNavItems () {

        let p = this.props.preference;
        var items = [];

        Object.keys(p).map(function (key) {
            if (typeof p[key] === 'object') {
                var nav = {};
                nav.key = key;
                nav.name = p[key].name;
                nav.sortOrder = p[key].sortOrder;
                items.push(nav);
            }
        });

        items.sort(function (a, b) {
            return a.sortOrder > b.sortOrder;
        });

        return items;
    }

    handleNav (item, ev) {
        ev && ev.preventDefault();
        this.props.toggleActiveTab(item);
        if (this.state.mobileOpen) this.toggleMobileView();
    }

    toggleMobileView (ev) {
        ev && ev.preventDefault();
        this.setState({
            mobileOpen: !this.state.mobileOpen
        });
    }

    render () {
        let items = this.getNavItems();
        let { mobileOpen } = this.state;
        let active = this.props.nav;

        return (<nav className="responsive-nav media__lessThan--sm">
            <ul className={mobileOpen ? 'mobile-nav__open' : ''}>

                <li className="mobile-nav-header">
                    <a href="#" onClick={this.toggleMobileView}>
                        Current Tab: <strong>{active.name}</strong>
                        <span className="icon">
                            {mobileOpen ?
                                <FaMinusCircle size={25}/> :
                                <FaPlusCircle size={25}/>
                            }
                        </span>
                    </a>
                </li>

                {items.map(function (i, k) {
                    return (<li key={k}
                        className={i.key == active.key ? 'active' : ''}>
                            <a href="#" onClick={this.handleNav.bind(null, i)}>
                                {i.name}
                            </a>
                    </li>)
                }, this)}
            </ul>
        </nav>);
    }
}

Navigation.propTypes = {};

export default Navigation;
